// extracted by mini-css-extract-plugin
module.exports = {"bullet":"bullet__Zacel","buttonGroup":"buttonGroup__1h+Jo","pagination":"pagination__1MAnr","perPage":"perPage__-Fsqr","totalCount":"totalCount__oHIKD"};